<template>
  <div class="member">
    <div class="member-content">
      <el-row :gutter="20" class="searchRow">
        <el-col :span="22">
          <!-- 查询框区域 -->
          <el-form
            :model="searchForm"
            size="mini"
            :inline="true"
            label-width="90px"
          >
            <el-form-item label="账号名称">
              <el-input
                clearable
                size="mini"
                v-model="searchForm.keyword"
                placeholder="请输入用户名或手机号搜索"
                style="width: 12vw"
              >
              </el-input>
            </el-form-item>
            <el-form-item label="角色类型">
              <el-select
                v-model="searchForm.roleId"
                placeholder="请选择"
                clearable
                style="width: 12vw"
              >
                <el-option
                  v-for="item in authoritylist"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="用户状态">
              <el-select
                v-model="searchForm.enable"
                placeholder="请选择"
                clearable
                style="width: 12vw"
              >
                <el-option
                  v-for="item in statusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="创建时间">
              <el-date-picker
                v-model="createTime"
                type="daterange"
                clearable
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                style="width: 12vw"
              >
              </el-date-picker>
            </el-form-item>
          </el-form>
        </el-col>
        <!-- 提交按钮 -->
        <el-col :span="2" class="searchbuttons">
          <div>
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-search"
              @click="filterData"
              >查询</el-button
            >
          </div>
          <div class="searchButton">
            <el-button
              type="info"
              size="mini"
              icon="el-icon-refresh-right"
              @click="reset"
              >重置</el-button
            >
          </div>
        </el-col>
      </el-row>
      <div class="left">
        <!-- <el-button
          type="primary"
          size="small"
          @click="skipfn"
          v-if="roleListFlag"
          >角色管理</el-button
        > -->
        <el-button
          type="primary"
          size="small"
          v-permission="'creat_account'"
          @click="addfn"
          >创建账号</el-button
        >
      </div>
      <el-dialog
        title="创建账号"
        :visible.sync="addflag"
        width="30%"
        :before-close="closefn"
      >
        <el-form :model="infoParams" ref="form" :rules="rules">
          <el-form-item label="账号：" prop="id" label-width="80px">
            <el-input
              @input="emptyfn"
              maxlength="20"
              v-model.trim="infoParams.id"
              :validate-event="false"
              placeholder="请输入账号"
            >
            </el-input>
          </el-form-item>
          <!-- <el-form-item label="密码：" label-width="80px">
            <el-input
              @input="emptyfn"
              maxlength="20"
              v-model.trim="infoParams.password"
              type="password"
              show-password
              placeholder="请输入密码"
            >
            </el-input>
          </el-form-item> -->
          <el-form-item label="姓名：" label-width="80px">
            <el-input
              @input="emptyfn"
              maxlength="20"
              v-model.trim="infoParams.name"
              placeholder="请输入姓名"
            >
            </el-input>
          </el-form-item>

          <el-form-item label="角色：" label-width="80px">
            <el-select
              @change="emptyfn"
              v-model.trim="infoParams.authority"
              placeholder="请选择角色"
              multiple
            >
              <el-option
                v-for="value in authoritylist"
                :key="value.id"
                :label="value.name"
                :value="value.id"
              ></el-option>
              <!-- <el-option label="1"></el-option> -->
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="closefn">取 消</el-button>
          <el-button type="primary" @click="addsubfn" :disabled="disabledflag"
            >确 定</el-button
          >
        </span>
      </el-dialog>
      <el-dialog
        title="配置角色"
        :visible.sync="editflag"
        width="30%"
        :before-close="closefn"
      >
        <el-form :model="eParams" ref="eform" :rules="rules">
          <el-form-item label="角色：" label-width="80px">
            <el-select
              v-model.trim="eParams.authority"
              placeholder="请选择角色"
              multiple
            >
              <el-option
                v-for="value in authoritylist"
                :key="value.id"
                :label="value.name"
                :value="value.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="closefn">取 消</el-button>
          <el-button
            type="primary"
            :disabled="eParams.authority?.length === 0"
            @click="editsubfn"
            >确 定</el-button
          >
        </span>
      </el-dialog>
      <!-- </div> -->
      <el-table :data="tableData" style="width: 100%">
        <el-table-column align="center" prop="realName" label="账号名称">
          <template slot-scope="scope">
            <div
              @click="goPersonalInfo(scope.row.id)"
              :style="{
                color: $jumpPerm('account_detail') ? '#165DFF' : '#606266',
                cursor: 'pointer',
              }"
            >
              {{ scope.row.realName }}
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="userName" label="手机号">
        </el-table-column>
        <el-table-column align="center" prop="roleName" label="角色">
        </el-table-column>
        <el-table-column align="center" prop="email" label="邮箱">
        </el-table-column>
        <el-table-column
          align="center"
          prop="createTimeString"
          label="创建日期"
        ></el-table-column>
        <el-table-column align="center" prop="enable" label="状态">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.enable"
              @change="handleStatuChange(scope.row.id, scope.row.enable)"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column align="center" fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button
              v-permission="'update_user_role'"
              @click="settingRole(scope.row)"
              type="text"
              size="small"
            >
              配置角色
            </el-button>
            <el-button
              v-permission="'del_account'"
              :disabled="scope.row.roleName?.includes('超级管理员')"
              @click="removeRole(scope.row)"
              type="text"
              size="small"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="page">
        <el-pagination
          layout="->,total,prev, pager, next"
          @current-change="currentChangefn"
          :total="total"
          :page-size="size"
          :current-page="page"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {
  requestUserAdminList,
  requestUserRoleList,
  userAddAdmin,
  requestUserRemoveAdmin,
  userEditAdmin,
} from "@/api/userApi";
import { formatDate } from "@/utils/util";
export default {
  name: "member",
  data() {
    return {
      searchForm: {
        keyword: "",
        roleId: "",
        enable: "",
        start: "",
        end: "",
      },
      createTime: "",
      statusOptions: [
        {
          value: 1,
          label: "启用",
        },
        {
          value: 0,
          label: "禁用",
        },
      ],
      disabledflag: true,
      makflag: false,
      addflag: false,
      editflag: false,
      disabledEditflag: true,
      page: 1,
      size: 10,
      total: 0,
      activeId: null,
      infoParams: {
        id: "",
        authority: [],
        name: "",
      },
      eParams: {
        authority: [],
      },
      rules: {
        id: [
          {
            pattern:
              /^((13[0-9])|(14[0-9])|(15[0-9])|(17[0-9])|(18[0-9])|(19[0-9]))\d{8}$/,
            message: "请输入正确的手机号作为账号",
            trigger: "blur",
          },
        ],
      },
      authoritylist: [],
      tableData: [
        {
          id: "admin",
          name: "admin",
          authority: "admin",
        },
      ],
    };
  },
  created() {
    this.init();
  },
  computed: {
    addUserFlag() {
      //创建账号权限控制
      return (
        this.$store.state.userInfo.permissions.includes("addAdminUser") ||
        this.$store.getters.isAdmin
      );
    },
    updateRoles() {
      //编辑账号权限控制
      return (
        this.$store.state.userInfo.permissions.includes("update_user_role") ||
        this.$store.getters.isAdmin
      );
    },
    roleListFlag() {
      //查看角色列表权限管理
      return (
        this.$store.state.userInfo.permissions.includes("roleList") ||
        this.$store.getters.isAdmin
      );
    },
    //删除账号权限控制
    delFlag() {
      return (
        this.$store.state.userInfo.permissions.includes("del_account") ||
        this.$store.getters.isAdmin
      );
    },
  },
  methods: {
    init() {
      this.requestUserAdminListfn();
      this.requestUserRoleListfn();
    },
    async requestUserRemoveAdminfn() {
      var res = await requestUserRemoveAdmin({
        id: this.activeId,
      });
      return res;
    },
    async userAddAdminfn() {
      var res = await userAddAdmin({
        userName: this.infoParams.id,
        // roleId: this.infoParams.authority,
        roles: this.infoParams.authority,
        // password: this.infoParams.password,
        realName: this.infoParams.name,
      });
      if (res.data.code == 1000) {
        this.$message({
          message: "创建成功",
          type: "success",
        });
      } else {
        this.$message({
          message: res.data.msg,
          type: "error",
        });
      }
    },
    async requestUserRoleListfn() {
      var res = await requestUserRoleList({
        page: 0,
        size: 0,
      });
      // var arr = res.data.data.result.list;
      var arr = res.data.data.list;
      console.log("res.data", res.data.data.list);

      // arr.splice(
      //   arr.findIndex((item) => item.name == "超级管理员"),
      //   1
      // );
      this.authoritylist = arr;
    },
    async requestUserAdminListfn() {
      if (this.createTime) {
        this.searchForm.start = formatDate(this.createTime[0], "YYYY-MM-DD");
        this.searchForm.end = formatDate(this.createTime[1], "YYYY-MM-DD");
      }
      var res = await requestUserAdminList({
        ...this.searchForm,
        page: this.page,
        size: this.size,
      });
      this.tableData = res.data.data.list;
      this.tableData.forEach((item) => {
        item.enable = item.enable === 1;
        if (item.roleList) {
          item.roleName = item.roleList.map((item) => item.name).join("、");
        }
      });
      this.total = res.data.data.count;
    },
    skipfn() {
      this.$router.push("/role");
    },
    currentChangefn(index) {
      this.page = index;
      this.requestUserAdminListfn();
    },
    removefn() {
      this.$confirm("确定删除该账号吗?", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.requestUserRemoveAdminfn().then((res) => {
            if (res.data.code == 1000) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.init();
            this.closefn();
          });
        })
        .catch(() => {});
    },
    emptyEditfn() {
      if (this.infoParams.authority == "" || this.infoParams.name == "") {
        this.disabledEditflag = true;
      } else {
        this.disabledEditflag = false;
      }
    },
    emptyfn() {
      this.disabledflag = ["id", "name", "authority"].some(
        (k) => !this.infoParams[k]
      );
    },
    closefn() {
      this.makflag = false;
      this.addflag = false;
      this.editflag = false;
      this.infoParams = {
        id: "",
        password: "",
        authority: "",
      };
      this.eParams = {
        authority: "",
      };
      this.emptyfn();
      this.emptyEditfn();
    },
    addfn() {
      this.makflag = true;
      this.addflag = true;
    },
    async addsubfn() {
      var res = await this.userAddAdminfn();
      this.makflag = false;
      this.addflag = false;
      this.infoParams = {
        id: "",
        password: "",
        authority: "",
      };
      this.emptyfn();
      this.init();
    },
    settingRole(user) {
      this.eParams = {
        id: user.id,
        authority: user.roleList?.map((r) => r.id) || [],
      };
      this.editflag = true;
    },
    async editsubfn() {
      const formData = new FormData();
      formData.append("id", this.eParams.id);
      formData.append("roles", this.eParams.authority?.join(",") || "");
      var res = await userEditAdmin(formData);

      if (res.data.code == 1000) {
        this.$message({
          message: "配置成功",
          type: "success",
        });
      } else {
        this.$message({
          message: res.data.msg,
          type: "error",
        });
      }
      console.log(res, 444);
      this.makflag = false;
      this.editflag = false;
      this.infoParams = {
        id: "",
        password: "",
        authority: "",
      };
      this.emptyEditfn();
      this.init();
    },
    // 查询
    async filterData() {
      if (this.createTime) {
        this.searchForm.start = formatDate(this.createTime[0], "YYYY-MM-DD");
        this.searchForm.end = formatDate(this.createTime[1], "YYYY-MM-DD");
      }
      const { data } = await requestUserAdminList({
        ...this.searchForm,
        page: this.page,
        size: this.size,
      });
      if (data.code === 1000) {
        this.tableData = data.data.list;
        this.tableData.forEach((item) => {
          item.enable = item.enable === 1;
          if (item.roleList) {
            item.roleName = item.roleList.map((item) => item.name).join("、");
          }
        });
        this.total = data.data.count;
      }
    },
    // 重置
    reset() {
      (this.searchForm = {
        keyword: "",
        roleId: "",
        enable: "",
        start: "",
        end: "",
      }),
        (this.createTime = "");
      this.init();
    },
    // 切换账号状态
    async handleStatuChange(id, statu) {
      const enable = statu ? 1 : 0;
      const formData = new FormData();
      formData.append("id", id);
      formData.append("enable", enable);
      const { data } = await userEditAdmin(formData);
      if (data.code === 1000) {
        this.init();
      } else {
        this.$message.error(data.msg);
        this.init();
      }
    },
    // 删除账号
    removeRole(row) {
      console.log(row.id);
      this.activeId = row.id;
      this.removefn();
    },
    // 跳转用户详情
    goPersonalInfo(row) {
      if (this.$jumpPerm("account_detail")) {
        const params = JSON.stringify(row);
        this.$router.push({
          path: "/userInfo",
          query: {
            params,
            fromAccountList: true,
          },
        });
      }
      console.log(row);
      // this.$router.push({
      //   path: "/personalInfo",
      //   query: {
      //     ...row,
      //   },
      // });
    },
  },
};
</script>

<style lang="less">
.member {
  background-color: #fff;
  padding: 20px;
  /* min-height: 100%; */
  border: 20px solid #f3f3f3;
  box-sizing: border-box;
  thead tr .el-table__cell {
    background-color: #e3e3e3;
    color: #333;
  }
  .page {
    padding: 20px;
  }
  .dialog-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .red {
      color: red;
      cursor: pointer;
      float: left;
    }
  }

  .left {
    margin-bottom: 20px;
  }
  .member-content {
    padding: 15px;
    background-color: #fff;
  }
  // .el-form-item {
  // }
  // .el-input {
  //   // width: 178px !important;
  // }
  .el-form-item__content {
    flex: 1;
    .el-select {
      width: 100%;
    }
  }
}
</style>
>
